const state = {
  // 用户信息
  userData: '',
  // 账号下的小区权限
  userGardenList: [],
  gardenAreaByStaff: [],
  // 账号下的菜单权限
  userMunuList: [],
  // 全局的小区下拉的值
  gardenId: 0,
  
  isRelationButton: 0,
}

const mutations = {

  setIsRelationButton (state, isRelationButton) {
    state.isRelationButton = isRelationButton
  },
  setGardenId (state, gardenId) {
    state.gardenId = gardenId
  },
  setGroupId (state, groupId) {
    state.groupId = groupId
  },
  setEditPreInfoIsUseApprove (state, editPreInfoIsUseApprove) {
    state.editPreInfoIsUseApprove = editPreInfoIsUseApprove
  },
  // 登录成功储存用户信息
  setUserData (state, userData) {
    // 清空缓存
    localStorage.clear()
    state.userData = userData
    state.userMunuList = userData.munuList
    
    if (userData.gardenList.length === 0) {
      // 没有小区的情况下添加‘空园区’占位
      state.userGardenList = [{
        id: 1,
        name: '该账号下无所属小区'
      }]
      state.gardenId = 1
    } else {
      state.userGardenList = userData.gardenList
      state.gardenAreaByStaff = userData.gardenAreaByStaff ? userData.gardenAreaByStaff : []
      state.gardenId = userData.gardenList[0].id
      state.isRelationButton = userData.gardenList[0].isRelationButton
    }
    console.log('userData', userData)
  },
  
  // 退出登录清空用户信息
  emptyUserData (state) {
    state.userData = {}
    state.userGardenList = []
    state.gardenAreaByStaff = []
    state.userMunuList = []
    // 清空缓存
    localStorage.clear()
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}